var _circle, _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.83203,
    cy: 6,
    r: 5.75,
    stroke: "#00394D",
    strokeWidth: 0.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4880_43277",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83203 12C7.61996 12 8.40018 11.8448 9.12813 11.5433C9.85609 11.2417 10.5175 10.7998 11.0747 10.2426C11.6318 9.68549 12.0738 9.02405 12.3753 8.2961C12.6768 7.56815 12.832 6.78793 12.832 6C12.832 5.21207 12.6768 4.43185 12.3753 3.7039C12.0738 2.97595 11.6318 2.31451 11.0747 1.75736C10.5175 1.20021 9.85609 0.758252 9.12813 0.456723C8.40018 0.155195 7.61996 4.98021e-07 6.83203 4.29138e-07L6.83203 6L6.83203 12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83203 12C7.61996 12 8.40018 11.8448 9.12813 11.5433C9.85609 11.2417 10.5175 10.7998 11.0747 10.2426C11.6318 9.68549 12.0738 9.02405 12.3753 8.2961C12.6768 7.56815 12.832 6.78793 12.832 6C12.832 5.21207 12.6768 4.43185 12.3753 3.7039C12.0738 2.97595 11.6318 2.31451 11.0747 1.75736C10.5175 1.20021 9.85609 0.758252 9.12813 0.456723C8.40018 0.155195 7.61996 4.98021e-07 6.83203 4.29138e-07L6.83203 6L6.83203 12Z",
    fill: "#00394D",
    stroke: "#00394D",
    mask: "url(#path-2-inside-1_4880_43277)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartialIcon);
export default __webpack_public_path__ + "static/media/partialIcon.d41d64043b2370365b8af4301b167f5b.svg";
export { ForwardRef as ReactComponent };